import React from 'react';
import styles from './LegalContent.module.css';
import SEO from '../components/SEO';
import ObfuscatedEmail from '../components/ObfuscatedEmail';

const PrivacyPolicy = () => {
  return (
    <div className={styles.legalPage}>
      <SEO
        title="Privacy Policy"
        description="Privacy Policy for All For You Home Health Care. Learn how we protect your personal and health information in compliance with HIPAA regulations."
        keywords="privacy policy, HIPAA compliance, patient privacy, health information, data protection, confidentiality"
        canonicalUrl="https://allforyouhc.com/privacy-policy"
      />
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>Privacy Policy</h1>
          <p>Last updated: January 2024</p>
        </div>

        <div className={styles.content}>
          <section className={styles.section}>
            <h2>Introduction</h2>
            <p>All For You Home Health Care ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services.</p>
          </section>

          <section className={styles.section}>
            <h2>Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We may collect personal information that you provide to us, including but not limited to:</p>
            <ul>
              <li>Name, address, and contact information</li>
              <li>Date of birth and Social Security number</li>
              <li>Medical history and health information</li>
              <li>Insurance information</li>
              <li>Emergency contact information</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and improve our home health care services</li>
              <li>Coordinate your care with healthcare providers</li>
              <li>Process insurance claims and billing</li>
              <li>Communicate with you about your care</li>
              <li>Comply with legal and regulatory requirements</li>
              <li>Maintain the safety and security of our services</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>HIPAA Compliance</h2>
            <p>All For You Home Health Care complies with the Health Insurance Portability and Accountability Act (HIPAA) of 1996 and is fully committed to maintaining strict safeguards to protect your personal health data. Any information provided to us is handled properly, treated as confidential, and managed in accordance with applicable federal and state privacy laws.</p>
            <p>Your health information will only be used and disclosed as permitted by HIPAA regulations and with your authorization when required.</p>
          </section>

          <section className={styles.section}>
            <h2>Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul>
              <li>Healthcare providers involved in your care</li>
              <li>Insurance companies for billing and payment</li>
              <li>Government agencies as required by law</li>
            </ul>
            <p>We will not sell, rent, or trade your personal information to third parties for marketing purposes.</p>
          </section>

          <section className={styles.section}>
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access and obtain a copy of your health information</li>
              <li>Request corrections to your health information</li>
              <li>Request restrictions on how we use your information</li>
              <li>Receive confidential communications</li>
              <li>File a complaint if you believe your privacy rights have been violated</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>Contact Us</h2>
            <p>If you have questions or concerns about this Privacy Policy or our privacy practices, please contact us:</p>
            <p><strong>All For You Home Health Care</strong></p>
            <p>40 N. Altadena Dr. Ste 200J, Pasadena, CA 91107</p>
            <p>Phone: <a href="tel:8189491031">(818) 949-1031</a></p>
            <p>Email: <ObfuscatedEmail /></p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
